export async function isUpdatable(): Promise<boolean> {
  return false;
}

export async function permissionGranted(): Promise<boolean> {
  return false;
}

export async function openSettingsIfNotAllowed(toastText?: string) {
  return false;
}

export async function install(
  version: string,
  url: string,
  progress?: (progress: number, total: number) => void,
  cb?: () => void,
) {
  cb?.();
}

export async function removeDownloaded(cb?: () => void) {
  cb?.();
}
